module.exports = __webpack_public_path__ + "img/2_190.90077e97.png";